import { writable } from "svelte/store";

export const showYourReport = writable(true);
